import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as constants from '../constants/system-setup-constants';

import type {List} from 'immutable';

export type SsAnnotationsStore = {
    annotationIcons: List<unknown>;
    annotationsIconsLoaded: boolean;
    annotationGroups: List<unknown>;
    annotationsGroupsLoaded: boolean;
};

const initialState = () => {
    return {
        annotationIcons: Immutable.List(),
        annotationsIconsLoaded: false,
        annotationGroups: Immutable.List(),
        annotationsGroupsLoaded: false,
    };
};

const actionsMap = {
    [constants.ANNOTATIONS_GROUPS_SUCCESS]: (state, action) => {
        return {
            annotationGroups: action.data,
            annotationsGroupsLoaded: true,
        };
    },
    [constants.ANNOTATIONS_ICONS_SUCCESS]: (state, action) => {
        return {
            annotationIcons: action.data,
            annotationsIconsLoaded: true,
        };
    },
    [constants.DISPOSE_SS_ANNOTATIONS_STORE]: () => {
        return initialState();
    },
};

export default createReducer<SsAnnotationsStore>(initialState(), actionsMap);
